import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify} from '../../helpers/utility';

export const agentHoldStart = () => {
  return {
    type: actionTypes.AGENT_HOLD_START,
  };
};

export const agentHoldFail = (error) => {
  return {
    type: actionTypes.AGENT_HOLD_FAIL,
    error: error,
  };
};

export const agentHoldSuccess = (agentId) => {
  return {
    type: actionTypes.AGENT_HOLD_SUCCESS,
  };
};

export const agentHold = (agentId, holdState) => {

  return (dispatch) => {
    dispatch(agentHoldStart());
    ctiRequest['CTI_HOLD'].agent_id = agentId;
    ctiRequest['CTI_HOLD'].state = holdState;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_HOLD'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_HOLD'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          dispatch(agentHoldSuccess(agentId));
        } else {
          notify('Hold Error: ' + result.data.response.reason, 'agent-hold');
          dispatch(agentHoldFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Hold Error', 'agent-hold');
        dispatch(agentHoldFail(err));
      });
  };
};
